import { useNavigate } from "react-router-dom";
import SingleSelectKendoGrid from "../../../Grid/Selectable/SingleSelectKendoGrid";
import { defaultAddButton } from "../../../Grid/Toolbar/DefaultAddButton";
import { defaultEditButton } from "../../../Grid/Toolbar/DefaultEditButton";
import PageHeader from "../../../Layout/Header/PageHeader";
import { bidPackUrls } from "../../../URL/ApplicationUrls";
import { combinedUrls } from "../../../URL/functions";
import { bidPackObjectName } from "../BidPack";
import { BidPackOverviewItem } from "../BidPackOverviewItem";
import { BidPackGridColumns } from "./BidPackGridColumns";
import { AuthorizationPolicies } from "../../../Auth/AuthorizationPolicy";
import { BidPackOverviewToolbarMenu } from "./BidPackOverviewToolbarMenu";

function BidPackOverview() {
  const navigate = useNavigate();

  const addBidPack = () => navigate(bidPackUrls.addBidPack.uiPath);
  const editBidPack = (bidPack: BidPackOverviewItem | undefined) =>
    bidPack && navigate(bidPackUrls.uiPathForBidPackWithId(bidPack.Id));

  const url = combinedUrls(bidPackUrls.base.apiUrl, "KendoGrid");

  return (
    <>
      <PageHeader headerText={bidPackObjectName} />
      <SingleSelectKendoGrid
        localStorageKey="BidPackOverviewGrid_DataState"
        fetchUrl={url}
        columns={BidPackGridColumns()}
        idSelector={(bidPack: BidPackOverviewItem) => bidPack.Id}
        toolbarItems={[
          defaultAddButton({
            onClick: addBidPack,
            roles: AuthorizationPolicies.RequireAdminNetworkRoles,
          }),
          defaultEditButton({
            onClick: editBidPack,
            roles: AuthorizationPolicies.RequireAdminNetworkRoles,
          }),
        ]}
        onRowDoubleClick={editBidPack}
        customToolbarItems={[BidPackOverviewToolbarMenu(url)]}
      />
    </>
  );
}

export default BidPackOverview;
